// Auto-extracted from app.jsx
import { BLOCKER_TYPES } from '../constants/blockerTypes';
import { analyzeNineQuestions } from './eqScoring';
import { formatDate } from './formatters';

export function analyzeBlockers(item, type) {
  const blockers = [];
  const analysis = analyzeNineQuestions(item);
  const now = new Date();
  
  // 1. Incomplete Nine Questions (score < 9)
  if (analysis.score < 9) {
    blockers.push({
      blockerType: BLOCKER_TYPES.INCOMPLETE_EQ,
      reason: `Missing ${9 - analysis.score} of 9 questions`,
      details: analysis.missing,
    });
  }
  
  // 2. Placeholder rationale detected in WHY field
  if (analysis.hasAnyPlaceholder) {
    const placeholderFields = analysis.results.filter(r => r.hasPlaceholder);
    blockers.push({
      blockerType: BLOCKER_TYPES.PLACEHOLDER,
      reason: "Placeholder text detected",
      details: placeholderFields.map(f => `${f.label}: "${f.placeholders.join('", "')}"`),
    });
  }
  
  // 3. Overdue review
  if (item.next_review_date) {
    const reviewDate = new Date(item.next_review_date);
    if (reviewDate < now) {
      const daysOverdue = Math.floor((now - reviewDate) / (1000 * 60 * 60 * 24));
      blockers.push({
        blockerType: BLOCKER_TYPES.OVERDUE_REVIEW,
        reason: `Review overdue by ${daysOverdue} day${daysOverdue !== 1 ? "s" : ""}`,
        details: [`Due: ${formatDate(item.next_review_date)}`],
      });
    }
  }
  
  // 4. Missing evidence (EVIDENCE field empty)
  if (!item.evidence_summary || item.evidence_summary.trim().length === 0) {
    blockers.push({
      blockerType: BLOCKER_TYPES.MISSING_EVIDENCE,
      reason: "No evidence documented",
      details: ["EVIDENCE field is empty"],
    });
  }
  
  return {
    item,
    type,
    eqScore: analysis.score,
    blockers,
    isBlocking: blockers.some(b => b.blockerType.severity === "high"),
    hasWarnings: blockers.some(b => b.blockerType.severity === "medium"),
  };
}

// Aggregate all blockers from scenarios and thresholds